import { ButtonKVBase } from '@/presentation/components';
import React from 'react';
import Styles from './plan-styles.scss';
const Plan = ({ onClickButton, colorDetail = '#695CFF', title1, title2, price, detail, detailText, subtitle, disabled = false, planName, buttonText = 'Sign up' }) => {
    const onButtonClick = () => {
        if (!disabled)
            onClickButton();
    };
    return (React.createElement("div", { className: Styles.mobilePlan, "data-testid": `wrapper-${planName}` },
        React.createElement("div", { className: Styles.left },
            React.createElement("div", { className: Styles.title1 }, title1),
            React.createElement("div", { className: Styles.title2 }, title2),
            React.createElement("div", { className: Styles.title3 }, price),
            React.createElement("div", { className: Styles.title4 }, subtitle),
            React.createElement("div", { className: Styles.detailWrap },
                React.createElement("div", { style: { color: colorDetail } }, detail))),
        React.createElement("div", { className: Styles.divHR }),
        React.createElement("div", { className: Styles.right },
            React.createElement("div", { className: Styles.description }, detailText),
            disabled ? (React.createElement("div", { style: { cursor: 'not-allowed' } },
                React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", testId: `sign-up-${planName}`, inactivePointerEvents: true }, buttonText))) : (React.createElement(ButtonKVBase, { type: "button", onClick: onButtonClick, btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", testId: `sign-up-${planName}` }, buttonText)))));
};
export default Plan;
